import { AppProviders } from './providers';
import { AppRouter } from './router';

/**
 * Root App component — wraps everything in providers and renders the router.
 */
export function App() {
    return (
        <AppProviders>
            <AppRouter />
        </AppProviders>
    );
}

export default App;
